// https://github.com/giantcz/gia
// Add import to js/components
import Component from 'gia/Component'

export default class AccordianComponent extends Component {

  constructor(element) {
    super(element);

    this.isOpen = false
    
    this.ref = {
      trigger: null,
      content: null
    } 
  }

 
  mount() {
    this.ref.content.style.display = 'none'
    this.ref.trigger.addEventListener('click', this.toggleContent.bind(this));
  }


  toggleContent(e) {
    e.preventDefault(); 
    this.isOpen = !this.isOpen
    this.element.classList.toggle('show'); 

    if (this.isOpen) {
      this.ref.content.style.display = 'block'
    } else {
      this.ref.content.style.display = 'none'
    }
  }

}
